var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1111_5050",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1111_5050",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAADR0lEQVR4nO2cP2sUQRiHn2hyEvwDImgUBBEsLMTCIlhooZUWkkKs1FY0hV/Br+BXiGBnZaFYaBGMJoqFSCwEFQIWAVFyEfFfzmJ3MZ65vZ135mbn1t8DLyk2O+87D7tzuzPLgBBCCCGEEEIIIYQQQog+tIBp4AmwCnQUdHIXc8A1YMxsN2cv8DyBTqUez4AJo2NaSLJLLGC8sqcTKH7Y4movmZtKRF8qOSY2pqezkZKT2sC28LU0mjaww/Uk6+3zANgTouqa2AXcxd5/Z3zGqiXgpCVpzUwCb/HruzO+Pww/gRvAZkvyyIwA14Hv+PfbmVC/xA+BfZYCIrEbuE+4/joTKnEHWAbOWIoYMKeAD4TtqzMhk3eANeAmAV5XAzBKNqz9Inw/nQldQBELwEFLQYHYD8xuUFfSoueMxXwEpixFeTKV57bUXLWvzlRp1PcWnAHGLcU5soVs2Foz1FgMea2K/++MS6Onsf+ovAAOWQqsyAHgqbG2ZeDsurZqFw1+j0krwEVLkX04D3wy1vSIfx9LkxAN/g/+M8BWS7FdjJPd7pYayl60khFdMAm8M3b0NXDUUnDOYeClMXe/qYPkRIPf5MxXsjvDlcvAF2POKpNhSYqGP0PJt4rtdccdYGeFPNuB28YcP8iGirK5+YJkRRccA95UbLM73gPHa2q7m+RFQ/irLtbdsp6hEF0QYhytY/ynYvtpNJpzBFismKM7lvKwnLuY57YydKLB71nXEiGe0YdSdIHP21uVCPnWOdSiwW8+oixCz6MMvWjwm2HrNVSEnhlshOiCc9jnjDvAZ+DCgGprlGiwr4LMM9jVm8aJBrdFhVjrkY0UXdBvpTrmCnujRUO2qHBvg/yxvxlpvGj4e1Ghrq+gzE7KviatIrLs/EFxIv87W0Nus5NhFF0nZidVJrtFACQ6EhIdCYmOhERHQqIjIdGRkOhISHQkJDoSEh0JiY6EREdCoiMh0ZGQ6EhIdCRGS46t0n9jlNjrhqmz0utA2RX9agCFNJ2ezspE3xpAIU3H5KxFtp+b62dZ/2vM4/Gl1ATZbgR1dyL1mMdjg8GCMbL93B6T7YJVd6dSiXbu5App7EEihBBCCCGEEEIIIYQQKfMbMeahpP7wOZQAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.f49875229b4478577212b89310312f6e.svg";
export { ForwardRef as ReactComponent };